const badges = [
  { icon: 'ri-database-2-line', text: 'Updated Product Database' },
  { icon: 'ri-folders-line', text: 'Organized Product Categories' },
  { icon: 'ri-scales-3-line', text: 'Detailed Comparison Guides' },
  { icon: 'ri-user-smile-line', text: 'Beginner Friendly Tutorials' },
  { icon: 'ri-shield-check-line', text: 'Safety & Verification Resources' },
];

export default function TrustBadges() {
  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-5xl mx-auto flex flex-wrap items-center justify-center gap-6 md:gap-10">
          {badges.map((badge) => (
            <div key={badge.text} className="flex items-center gap-2.5 text-foreground-700">
              <div className="w-9 h-9 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
                <i className={`${badge.icon} text-accent-600 text-base`}></i>
              </div>
              <span className="text-sm font-medium whitespace-nowrap">{badge.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}